module.exports = __webpack_public_path__ + "img/sumiao19.be7c86ed.png";